export const OTHER_GENERAL_QUESTIONS_DATA_REQUEST =
  'OTHER_GENERAL_QUESTIONS_DATA_REQUEST';
export const OTHER_GENERAL_QUESTIONS_DATA_SUCCESS =
  'OTHER_GENERAL_QUESTIONS_DATA_SUCCESS';
export const OTHER_GENERAL_QUESTIONS_DATA_FAIL =
  'OTHER_GENERAL_QUESTIONS_DATA_FAIL';
